import { Link } from 'react-router-dom';
import { useAppSelector } from '@/hooks/useAppSelector';
import { moduleSubscriptionLink } from '@/config/moduleWorkspace';

export function PlanLimitNotice({ message }: { message: string }) {
  const entryModule = useAppSelector((s) => s.auth.entryModule);
  const enabledModules = useAppSelector((s) => s.auth.enabledModules);
  const module = entryModule ?? enabledModules[0] ?? 'POS';

  return (
    <div className="mb-4 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-900 dark:border-amber-800 dark:bg-amber-950/40 dark:text-amber-100">
      {message}{' '}
      <Link to={moduleSubscriptionLink(module as never)} className="font-medium underline">
        View subscription
      </Link>
    </div>
  );
}
